import * as t from "io-ts"

export const InviteDetails = t.type({
    organisationId: t.string,
    organisationName: t.string,
    organisationType: t.union([
        t.literal("installer"),
        t.literal("manufacturer"),
    ]),
    inviter: t.string,
    userId: t.string,
})

export const PendingInviteFound = t.type({
    invite_exists: t.literal(true),
    detail: InviteDetails,
})

export const PendingInviteNotFound = t.type({
    invite_exists: t.literal(false),
    detail: t.null,
})

export const PendingInvite = t.union([
    PendingInviteFound,
    PendingInviteNotFound,
])

export type IPendingInvite = t.TypeOf<typeof PendingInvite>
export type IInviteDetails = t.TypeOf<typeof InviteDetails>
